// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"a5-z","displaySixCardTiles":"b5-z"};